module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background",
    class: {
      'longCont1': _vm.long
    }
  }, [_c('div', {
    staticClass: "chart-container",
    class: {
      'longCont': _vm.long
    }
  }, [_c('div', {
    staticClass: "noPrint",
    on: {
      "click": _vm.printPdf
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-main-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('dayBydayRe')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$t('period')) + ": " + _vm._s(_vm.staTime) + "-" + _vm._s(_vm.endTime))])])]), _vm._v(" "), _c('table', {
    staticClass: "status-table1",
    class: {
      'zh11': !_vm.isEn, 'de1': _vm.isDe || _vm.isIt || _vm.isFr
    }
  }, [_c('tr', [_c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', {
    staticClass: "td2",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.username))]), _vm._v(" "), _c('td', {
    staticClass: "td1 td2"
  }, [_vm._v(_vm._s(_vm.$t('fullName')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.statics.name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('devices')))]), _vm._v(" "), _c('td', {
    staticClass: "td2",
    attrs: {
      "id": "reportPdmTitle"
    }
  }, [_vm._v(_vm._s(_vm.$t('pdm')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('tran')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td2"
  }, [_vm._v(_vm._s(_vm.$t('pumpBase')))]), _c('td', {
    staticClass: "td3",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.devices[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1 td4"
  }, [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', {
    staticClass: "td4",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.statics.medical_history))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-hr"
  }), _vm._v(" "), _vm._l((_vm.pagePos), function(base, p) {
    return _c('div', [(p == 1) ? _c('div', [_c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "page-seperator"
    }), _vm._v(" "), _c('div', {
      staticClass: "page-starter"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "page-charts"
    }, _vm._l((_vm.src2_1.slice(base, base + _vm.perPage[p])), function(url, index) {
      return _c('div', {
        staticClass: "imgCotain"
      }, [_c('div', {
        staticClass: "date date-spe3"
      }, [_c('span', [_vm._v(_vm._s(_vm.date[base + index]))])]), _vm._v(" "), _c('div', {
        staticClass: "eat-label eat-spe3",
        class: {
          'zh1': !_vm.isEn, 'de11': _vm.isDe, 'po1': _vm.isPo || _vm.isFr
        }
      }, [_c('span', {
        staticClass: "eat-label-spe1",
        class: {
          'zh2': !_vm.isEn, 'de2': _vm.isDe, 'po2': _vm.isPo || _vm.isFr
        }
      }, [_vm._v(_vm._s(_vm.$t('Breakfast')))]), _vm._v(" "), _c('span', {
        class: {
          'zh3': !_vm.isEn, 'de3': _vm.isDe, 'po3': _vm.isPo || _vm.isFr
        }
      }, [_vm._v(_vm._s(_vm.$t('Lunch')))]), _vm._v(" "), _c('span', {
        class: {
          'zh4': !_vm.isEn
        }
      }, [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _c('img', {
        staticClass: "img",
        attrs: {
          "src": url
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "carb"
      }, [_c('span', [_vm._v(_vm._s(_vm.$t('carbs')) + "(g)")]), _vm._v(" "), _c('div', {
        attrs: {
          "id": 'carb' + (base + index)
        }
      }, [_vm._l((_vm.carb[base + index]), function(i) {
        return _c('label', [_vm._v(_vm._s(i[1]))])
      }), _vm._v(" "), _vm._l((_vm.autoBreakfast[base + index]), function(b) {
        return _c('img', {
          staticClass: "breakfast",
          attrs: {
            "src": "/static/legend/automode/早餐.png"
          }
        })
      }), _vm._v(" "), _vm._l((_vm.autoLunch[base + index]), function(b) {
        return _c('img', {
          staticClass: "lunch",
          attrs: {
            "src": "/static/legend/automode/中餐.png"
          }
        })
      }), _vm._v(" "), _vm._l((_vm.autoDinner[base + index]), function(b) {
        return _c('img', {
          staticClass: "dinner",
          attrs: {
            "src": "/static/legend/automode/晚餐.png"
          }
        })
      }), _vm._v(" "), _vm._l((_vm.autoSnack[base + index]), function(b) {
        return _c('img', {
          staticClass: "snack",
          attrs: {
            "src": "/static/legend/automode/零食.png"
          }
        })
      })], 2)]), _vm._v(" "), _c('img', {
        staticClass: "img",
        attrs: {
          "src": _vm.src2_2[base + index]
        }
      })])
    }))])
  }), _vm._v(" "), (_vm.chartEndPage.show) ? _c('div', [_c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-seperator"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-starter"
  })]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "legend-group",
    class: {
      'zh5': !_vm.isEn, 'it5': _vm.isIt, 'po5': _vm.isPo, 'du5': _vm.isDu || _vm.isFr || _vm.isCz
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/Alert.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('alert')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/target.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('target')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/hypo.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('hypo')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    staticClass: "img-spe",
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/SG.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('sensorGlucose')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/calib.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('calib')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend "
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/transmitter.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('newSen')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/warm up.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('warm')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh6': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/basal.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('basal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh7': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/temp basal.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('tampBasal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe3",
    class: {
      'zh8': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/normal bolus.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('normalBolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe4",
    class: {
      'zh9': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/extend bolus.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('extendBolus')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe5",
    class: {
      'zh10': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/auto suspend.png")
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('manualStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1",
    class: {
      'zh11': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/Auto Suspend 2.png")
    }
  }), _c('span', {
    staticClass: "span1"
  }, [_vm._v(_vm._s(_vm.$t('autoStop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe1"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/patch Deactivated.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('stop')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe6",
    class: {
      'zh12': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/new Patch.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('newPatch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe7",
    class: {
      'zh13': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/carbs.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('carbs')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend legend-spe2",
    class: {
      'zh14': !_vm.isEn
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/exercise.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('exercise')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/calibrate_1.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('BG Reading')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/automode/早餐.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Breakfast')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/automode/中餐.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Lunch')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/automode/晚餐.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Dinner')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/automode/零食.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_Snack')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/automode/icon_histogram.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_basal')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hcp-icon/legend/automode/auto_bolus.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('t1222_auto_bolus')))])])]), _vm._v(" "), _c('div', {
    staticClass: "page-end"
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-left"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/LOGO.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9672808"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print-htmplate/chart2_print.vue
// module id = 1508
// module chunks = 7